import { Button } from '#app/components/ui/button.tsx'
import { Typography } from '#app/components/ui/typography.tsx'
import { cn } from '#app/utils/misc.tsx'

export interface Props {
	className?: string
	onRequestHelp?: () => void
}

export function HelpCta({ className, onRequestHelp }: Props) {
	return (
		<div
			className={cn(
				'border-primary/20 bg-background rounded-lg border p-4 shadow-sm',
				'space-y-3',
				className,
			)}
		>
			<div className="space-y-1">
				<Typography.Subtitle>Need a hand?</Typography.Subtitle>
				<Typography.Description className="text-xs">
					Schedule a call with our team or let Lydra prefill the intake for you.
				</Typography.Description>
			</div>
			<Button type="button" className="w-full" onClick={onRequestHelp}>
				I need help
			</Button>
		</div>
	)
}
